<template>
  <v-app>
    <v-tabs v-model="active" color="primary" dark slider-color="yellow">
      <v-tab :key="2" ripple> {{ $t("captainCreatePage.vehicleTab") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pe-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("captainCreatePage.vehicleInformation") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <!--<v-select
                                    outline
                                    v-model="model.brand"
                                    label="Brand"
                                    :items="allBrands"
                                    @change="getTypes"
                                    dense>
                                  </v-select>-->

                    <v-autocomplete
                      v-model="model.brand"
                      :items="allBrands"
                      outline
                      hide-no-data
                      item-text="Description"
                      :label='$t("captainCreatePage.selectBrand")'
                      :placeholder='$t("captainCreatePage.startTypingToSearch")'
                      @change="getTypes"
                    ></v-autocomplete>
                    <!--<v-select
                                    id="ss"
                                    outline
                                    v-model="model.type"
                                    label="Type"
                                    :items="allTypes"
                                    :disabled="!model.brand"
                                    dense>
                                  </v-select>-->

                    <v-autocomplete
                      v-model="model.type"
                      :items="allTest"
                      outline
                      hide-no-data
                      item-text="name"
                      item-value="id"
                      :label='$t("captainCreatePage.selectModel")'
                      :placeholder='$t("captainCreatePage.startTypingToSearch")'
                      :disabled="!model.brand"
                      return-object
                      @change="testFunction"
                    ></v-autocomplete>
                    <!--<v-select
                                    outline
                                    v-model="model.color"
                                    label="Color"
                                    :items="allColors"
                                    dense>
                                  </v-select>-->

                    <v-autocomplete
                      v-model="model.color"
                      :items="allColors"
                      outline
                      hide-no-data
                      item-text="Description"
                      :label='$t("captainCreatePage.selectCarColor")'
                      :placeholder='$t("captainCreatePage.startTypingToSearch")'
                    ></v-autocomplete>

                    <v-text-field
                      outline
                      v-model="model.bluetooth_box_number"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.bluetoothBoxNumber")'
                      type="text"
                      grow
                    >
                    </v-text-field>
                    <v-text-field
                      outline
                      v-model="model.plate_number"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.plateNumber")'
                      type="text"
                      grow
                    ></v-text-field>

                    <v-select
                      outline
                      v-model="model.vehicle_type"
                      :rules="[rules.required]"
                      item-text="name"
                      item-value="id"
                      :label='$t("captainCreatePage.vehicleTypes")'
                      :items="vehicleTypes"
                      dense
                      return-object
                    ></v-select>
                    <v-select
                      outline
                      v-model="model.constraints"
                      :label='$t("captainCreatePage.constraints")'
                      :items="car_constraints"
                      multiple
                      dense
                    ></v-select>
                    <v-text-field
                      outline
                      v-model="model.technical_control_expiry_date"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.technicalControlExpiryDate")'
                      type="date"
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.renewal_document_expiry_date"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.renewalDocumentExpiryDate")'
                      type="date"
                    ></v-text-field>
                    <v-text-field
                      outline
                      v-model="model.metrological_log_expiry_date"
                      :rules="[rules.required]"
                      :label='$t("captainCreatePage.metrologicalLogExpiryDate")'
                      type="date"
                    ></v-text-field>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 grow ps-4>
              <v-layout align-start justify-start column>
                <h1 class="headline">{{ $t("captainCreatePage.documentsInfo") }}</h1>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-layout
                    style="gap: 20px; row-gap: 0px"
                    align-start
                    row
                    xs12
                    row
                    wrap
                  >
                    <upload-file
                      @change="model.assurance = $event"
                      :documentName='$t("captainCreatePage.assurance")'
                    />

                    <upload-file
                      @change="model.registration_certificate = $event"
                      :documentName='$t("captainCreatePage.registrationCertificate")'
                    />

                    <upload-file
                      class="docs"
                      @change="model.technical_control = $event"
                      :documentName='$t("captainCreatePage.technicalControl")'
                    />
                    <upload-file
                      class="docs"
                      @change="model.renewal_document = $event"
                      :documentName='$t("captainCreatePage.renewalDocument")'
                    />
                    <upload-file
                      class="docs"
                      @change="model.metrological_log = $event"
                      :documentName='$t("captainCreatePage.metrologicalLog")'
                    />
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-btn
            @click="addCaptainCar"
            :loading="loading"
            color="secondary"
            class="tbtn"
            >{{ $t("captainCreatePage.addCar") }}</v-btn
          >
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>
<style>
.tbtn {
  float: inline-end;
  margin-top: -40px;
  margin-inline-end: 24px;
  padding: 0px 65px;
}
.docs {
  margin-bottom: 3px;
}
</style>
<script>
import axios from "axios";
import UploadFile from "@/components/widgets/UploadFile.vue";

export default {
  title() {
    return this.$t("captainCreatePage.pageTitleCaptains");
  },
  components: {
    UploadFile,
  },
  created() {
    // console.log(this.$route.params.id);
  },
  data: () => ({
    active: 0,

    loading: false,
    error: false,
    searchQuery: null,
    selectedBrands: [],
    allTest: [],
    brandsList: [],

    colorItem: { id: "", name: "" },
    colorsList: [],

    languageItem: { id: "", name: "" },
    spokenLanguagesList: [],
    spokenLanguagesIds: [],

    requiredDocuments: {},
    model: {
      //vehicle

      brand: "",
      type: "",
      color: "",
      bluetooth_box_number: "",

      accepts_pets: 0,
      wheel_chair: 0,
      vehicle_type: "",
      plate_number: "",

      constraints: [], //vehicle constraints
      insurance_document_front: "",
      car_document_front: "",

      assurance: "",
      registration_certificate: "",
      technical_control: "",
      renewal_document: "",
      metrological_log: "",

      technical_control_expiry_date: "",
      renewal_document_expiry_date: "",
      metrological_log_expiry_date: "",
    },
    // gender: ["Male", "Female"],
    payment: ["CASH", "PAYMENT"],
    vehicleTypes: [],
    allBrands: [],
    allColors: [],
    allLanguages: [],
    allTypes: [],
    car_constraints: [],
    captain_constraints: [],

    form: false,
    isLoading: false,
    password: undefined,
  }),
  computed: {
    rules() {
      return {
        email: (v) =>
          !!(v || "").match(/@/) || this.$t("captainCreatePage.ruleEmail"),
        length: (len) => (v) =>
          (v || "").length >= len ||
          this.$t("captainCreatePage.ruleLength", { len }),
        password: (v) =>
          !!(v || "").match(/^.{8,15}$/) ||
          this.$t("captainCreatePage.rulePassword"),
        phoneNumber: (v) =>
          (!!v &&
            v.search(
              /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
            ) !== -1) ||
          this.$t("captainCreatePage.rulePhone"),

        required: (v) => !!v || this.$t("captainCreatePage.ruleRequired"),
        numberOfLicense: (v) =>
          !!(v || "").match(/^[0-9]*$/) ||
          this.$t("captainCreatePage.ruleLicense"),
      };
    },
  },
  mounted() {
    // Disabled: stop calling /api/user/language
    // axios.get(this.api.ACTIONS.LANGUAGES).then((response) => {
    //   for (let i = 0; i < response.data.data.length; i++) {
    //     this.allLanguages.push(response.data.data[i].name);
    //     let obj = { id: "", name: "" };
    //     obj.id = response.data.data[i].id;
    //     obj.name = response.data.data[i].name;
    //     this.spokenLanguagesList.push(obj);
    //   }
    // });
    axios.get("vehicle_type").then((response) => {
      response.data.data.data.forEach((item) => {
        this.vehicleTypes.push({
          name: item.name,
          id: item.id,
        });
      });
      console.log(this.vehicleTypes);
    });

    axios.get(this.api.ACTIONS.CAR_BRANDS).then((response) => {
      // console.log(response.data.data);
      for (let i = 0; i < response.data.data.length; i++) {
        this.allBrands.push(response.data.data[i].name);
        let obj = { id: "", name: "" };
        obj.id = response.data.data[i].id;
        obj.name = response.data.data[i].name;
        this.brandsList.push(obj);
        // console.log(this.brandsList[i]);
      }
      console.log(this.brandsList);
    });
    // axios.get(`constraints/car`).then((data) => {
    //   //
    //   console.log("car constraints");
    //   console.log(data.data.data);
    //   this.car_constraints = data.data.data;
    // });

    // Disabled: stop calling /api/user/dynamic_constraints
    // axios.get(`dynamic_constraints`).then((data) => {
    //   data.data.data.data.forEach((cons) => {
    //     if (cons.entity_type == "CAR") {
    //       this.car_constraints.push(cons.constraint_name);
    //     }
    //   });
    // });

    axios.get(`constraints/captain`).then((data) => {
      //
      console.log("captain constraints");
      console.log(data.data.data);
      this.captain_constraints = data.data.data;
      this.captain_constraints = this.captain_constraints.filter(
        (e) => e !== "PEXT"
      );
    });

    // Paginated endpoint: body is data.data.data; columns are name_en/name_ar
    // (there is no `name` column).
    axios.get(`${this.api.ACTIONS.COLORS}?perPage=100`).then((response) => {
      const colors = response.data.data.data || [];
      for (let i = 0; i < colors.length; i++) {
        const label = colors[i].name_en || colors[i].name_ar;
        this.allColors.push(label);
        this.colorsList.push({ id: colors[i].id, name: label });
      }
    });
  },

  methods: {
    testFunction() {
      console.log("ffs");
      console.log(this.model.type.id);
    },
    getTypes() {
      let id = "";
      // console.log(this.model.brand)
      // console.log(this.brandsList)
      for (let i = 0; i < this.brandsList.length; i++) {
        console.log(this.brandsList[i]);
        if (this.brandsList[i].name === this.model.brand)
          id = this.brandsList[i].id;
        // console.log(this.brandsList[i])
      }
      console.log(id);
      const typeUrl = this.api.ACTIONS.CAR_BRAND_MODELS(id);

      this.allTypes = [];
      axios.get(typeUrl).then((response) => {
        for (let i = 0; i < response.data.data.data.length; i++) {
          this.allTypes.push(response.data.data.data[i].name);
        }

        this.allTest = response.data.data.data;
        console.log("ALL TEST FFS");
        console.log(this.allTest);
      });
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },

    addCaptainCar() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();
        const docsFormData = new FormData();

        // const formData=new FormData();
        // const formData=new FormData();
        // this.model.gender = this.model.gender === "Male" ? 0 : 1;
        this.loading = true;
        console.log("documents: " + this.model.registration_certificate);
        formData.append("brand_model_id", this.model.type.id);
        for (let i = 0; i < this.colorsList.length; i++) {
          if (this.colorsList[i].name === this.model.color)
            formData.append("color_id", this.colorsList[i].id);
        }

        this.model.constraints.forEach((constraint) => {
          formData.append("car_constraints[]", constraint);
        });

        formData.append(
          "bluetooth_box_number",
          this.model.bluetooth_box_number
        );
        formData.append("vehicle_type", this.model.vehicle_type.id);

        formData.append("plate_number", this.model.plate_number);

        formData.append(
          "documents[Attestation d'assurance]",
          this.model.assurance
        );
        formData.append(
          "documents[Certificat d'immatriculation]",
          this.model.registration_certificate
        );
        formData.append(
          "documents[Contrôle technique]",
          this.model.technical_control
        );
        formData.append(
          "documents[Renouvèlement d'estampille]",
          this.model.renewal_document
        );
        formData.append(
          "documents[Carnet métrologique]",
          this.model.metrological_log
        );

        formData.append(
          "renewal_document_expiry_date",
          this.model.renewal_document_expiry_date
        );
        formData.append(
          "technical_control_expiry_date",
          this.model.technical_control_expiry_date
        );
        formData.append(
          "metrological_log_expiry_date",
          this.model.metrological_log_expiry_date
        );
        formData.append("captain_id", this.$route.params.id);
        console.log("formData" + formData);
        this.axios
          .post(this.api.ACTIONS.CAPTAIN_CAR, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit(
              "SHOW_TOAST",
              this.$t("captainCreatePage.captainCarAdded"),
              "green"
            );
            this.$router.push(`/captains/${this.$route.params.id}`);
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit(
                "SHOW_TOAST",
                this.$t("captainCreatePage.checkYourInfo"),
                "red"
              );
            }
          })
          .then(() => (this.loading = false));

        console.log(this.model);
      }
    },
  },
};
</script>
<style></style>
